import PrekMap from './tab-section-mappings/Pre-k-extra-wide-double-lines';
import TKGKG1Map from './tab-section-mappings/TKG-KG-1';
import FirstAndSecondMap from './tab-section-mappings/1st-2nd';
import SecondAndThirdCursive from './tab-section-mappings/2nd-3rd-cursive';
import thirdAndFourthAndFifthCursive from './tab-section-mappings/3rd-4th-5th-cursive';

const WorksheetsMap = (sectionId: number) => {
  switch (sectionId) {
    case 1:
      return PrekMap;
    case 2:
      return TKGKG1Map;
    case 3:
      return FirstAndSecondMap;
    case 4:
      return SecondAndThirdCursive;
    case 5:
      return thirdAndFourthAndFifthCursive;
    default:
      if (sectionId === undefined) throw new Error(`sectionId is: ${sectionId}`);
      else
        throw new Error(
          `worksheet map not found from sectionId: ${sectionId}, be sure to include a valid case in worksheetsMap.tsx`
        );
  }
};

export default WorksheetsMap;
